import { useQuery } from "react-query";
import { pos } from "@/platform";
import { useEstadoDeLaCaja } from "@/context/caja/estadoDeLaCaja";

export const MANDATO_QUERY_KEY = "caja-mandato";

/**
 * El mandato de la caja de este negocio y los cajeros con PIN (#346). Sale del
 * almacén de la caja, no del servidor: el latido lo guarda, y cuando cambia su
 * `id` se vuelve a leer. Se relee cada minuto: el vencimiento corre solo.
 */
export function useMandatoDeLaCaja(businessId: string | undefined) {
  const mandatoId = useEstadoDeLaCaja((s) => s.mandatoId);
  return useQuery(
    [MANDATO_QUERY_KEY, businessId, mandatoId],
    () => pos.mandateStatus(businessId as string),
    {
      enabled: pos.isAvailable && !!businessId,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
      refetchInterval: 60_000,
    }
  );
}
